import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from 'react-query';
import setToken from '../../utils/api';
import { IApiResponse } from '../../types/IApiResponse';
import { ILot } from '../../types/IOrderResponse';

interface UpdateThunderbirdPayload {
  kitLots: ILot[];
  boxLots: ILot[];
}

export default function useThunderbirdOrderUpdate(id: number | undefined) {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation<any, any, UpdateThunderbirdPayload>(
    ['thunderbird-order-update'],
    async (data: UpdateThunderbirdPayload) => {
      if (!id) {
        return null;
      }
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.put<IApiResponse<any>>(
        `api/thunderbird-orders/${id}`,
        {
          ...data,
        },
      );

      if (response.status !== 200) {
        throw new Error(
          response.data?.Message ?? response.data?.message ?? 'Request failed',
        );
      }
      return 'ok';
    },
    {
      // Returned so isLoading covers the refetch (see useUpdateOrder).
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries('thunderbird-order-details'),
          queryClient.invalidateQueries('thunderbird-order-list'),
        ]),
    },
  );
}
